import { Avatar, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { getGroupMemberIdentifier, type GroupMember } from "../model/types";

interface Props {
  member: GroupMember;
  isMobile: boolean;
}

export default function MemberItem({ member, isMobile }: Props) {
  const memberIdentifier = getGroupMemberIdentifier(member);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 16px",
        borderRadius: 12,
        border: "1px solid #f0f0f0",
        background: "#fff",
        marginBottom: 12,
      }}
    >
      <Avatar
        size={40}
        icon={<UserOutlined />}
        style={{
          backgroundColor: "#63b443",
          flexShrink: 0,
        }}
      />

      <div
        style={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: "#262626",
            marginBottom: 4,
          }}
        >
          {member.display_name}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <span
            style={{
              fontSize: 13,
              color: "#8c8c8c",
              wordBreak: "break-all",
            }}
          >
            {memberIdentifier}
          </span>

          <Tag
            color={member.role === "customer" ? "blue" : "green"}
            style={{
              margin: 0,
              borderRadius: 999,
            }}
          >
            {member.role === "customer" ? "お客様" : "セリ人"}
          </Tag>
        </div>

        {member.line_name && member.line_name !== member.display_name && (
          <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>
            LINE名: {member.line_name}
          </div>
        )}
        {member.phone_number && (
          <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>
            電話番号: {member.phone_number}
          </div>
        )}
      </div>
    </div>
  );
}
